import { PhoneForwarded, PhoneMissed } from 'lucide-react';

import { Button } from '../../../lib/button';
import { CallButtonsProps } from '../types';

const CallButtons: React.FC<CallButtonsProps> = ({ ongoingCall, setIsOpen, handleOutgoingCall, showIncomingCall }) => {
    const { call } = ongoingCall || {};
    const startText = showIncomingCall ? 'Answer' : 'Call';
    const endText = showIncomingCall ? 'Drop' : 'End call';

    const handleEnd = () => {
        if (showIncomingCall) call?.reject();
        else call?.disconnect();
    };
    const handleStart = () => {
        if (!call) handleOutgoingCall();
        if (call && showIncomingCall) call.accept();
    };

    return (
        <div className="flex gap-x-2">
            {!call && (
                <Button variant="outline-dark" className="text-base p-2" onClick={() => setIsOpen(false)}>
                    Close
                </Button>
            )}
            {call && (
                <Button variant="destructive" className="text-base" onClick={handleEnd}>
                    <PhoneMissed className="mr-2 h-5 w-5" />
                    {endText}
                </Button>
            )}
            {(!call || showIncomingCall) && (
                <Button variant="success" className="text-base" onClick={handleStart}>
                    <PhoneForwarded className="mr-2 h-5 w-5" />
                    {startText}
                </Button>
            )}
        </div>
    );
};
export default CallButtons;
